import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=9793d1b0&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=js"
export * from "./PopupDialog.vue?vue&type=script&lang=js"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=9793d1b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9793d1b0",
  null
  
)

export default component.exports